/* Cart line grouping helper (loaded once from layout/theme.liquid).
 *
 * Two hidden line-item properties:
 *  - _kg_cart_group : always set on every line added together. Used only by the theme
 *                     (cart page "Paket 1, 2 ..." headings, "remove whole package" button).
 *  - _group_id      : the "Shopify group ID" that the order integration (Ongoing WMS) reads.
 *                     Only set when the batch contains a cutting service (tillskärning /
 *                     sockeltillskärning), and then only on the tile itself and the cutting
 *                     lines, so the warehouse can pair the cutting job with the right tile.
 */
(function () {
  if (window.KGCartGroups) return;
  var CUTTING_METAFIELDS = ['tillskarning', 'sockel'];
  function isCutting(item) {
    if (!item) return false;
    var key = String(item.metafield || item.metafieldKey || '').toLowerCase();
    return CUTTING_METAFIELDS.indexOf(key) !== -1;
  }
  var TILE_PRODUCT_TYPES = ['Klinker & Kakel'];
  var CUTTING_PRODUCT_TYPE = 'Tillskärning';
  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  window.KGCartGroups = {
    cuttingMetafields: CUTTING_METAFIELDS,
    tileProductTypes: TILE_PRODUCT_TYPES,
    isCutting: isCutting,
    hasCutting: function (items) {
      return (items || []).some(isCutting);
    },
    /* True on the product page of a cutting service itself (Sockeltillskärning / Tillskärning). */
    currentProductIsCutting: function () {
      var type = window.currentProduct && window.currentProduct.type;
      return String(type || '') === CUTTING_PRODUCT_TYPE;
    },
    /* Decide the group for a batch before it is posted to /cart/add.js.
     * When a cutting service is added on its own (from its own product page, not together with a tile),
     * attach it to the newest tile already in the cart: reuse that tile line's group and make sure the
     * tile line carries _group_id too, so Ongoing can pair them. Falls back to a fresh group when the
     * cart holds no tile. Returns { groupId, hasCutting, mainRole }. */
    resolveBatch: async function (opts) {
      var groupId = String(opts.groupId);
      var tilval = opts.tilvalItems || [];
      var mainIsCutting = !!opts.mainIsCutting;
      var result = { groupId: groupId, hasCutting: mainIsCutting || tilval.some(isCutting), mainRole: mainIsCutting ? 'cutting' : 'main' };
      if (!mainIsCutting) return result;
      try {
        var cart = await (await fetch(cartRoot() + 'cart.js', { credentials: 'same-origin' })).json();
        var tile = (cart.items || []).find(function (line) { return TILE_PRODUCT_TYPES.indexOf(line.product_type) !== -1; });
        if (!tile) return result;
        var props = tile.properties || {};
        var tileGroup = String(props._kg_cart_group || props._group_id || groupId);
        result.groupId = tileGroup;
        if (props._group_id !== tileGroup || props._kg_cart_group !== tileGroup) {
          var newProps = {};
          for (var k in props) if (Object.prototype.hasOwnProperty.call(props, k)) newProps[k] = props[k];
          newProps._kg_cart_group = tileGroup;
          newProps._group_id = tileGroup;
          await fetch(cartRoot() + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ id: tile.key, quantity: tile.quantity, properties: newProps })
          });
        }
      } catch (error) {
        console.warn('[KG] could not attach cutting service to a tile in the cart', error);
      }
      return result;
    },
    /* groupId: id of the batch; role: 'main' | 'cutting' | 'other'; hasCutting: batch contains a cutting line */
    properties: function (groupId, role, hasCutting, extra) {
      var props = { _kg_cart_group: String(groupId) };
      if (hasCutting && (role === 'main' || role === 'cutting')) props._group_id = String(groupId);
      if (extra) for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) props[k] = extra[k];
      return props;
    }
  };
})();
